import { useInfiniteQuery, useQuery } from "@tanstack/react-query";

import { getCompany, listCompanies } from "../../api/companies";
import type { CompanyQuery } from "../../api/companies";

export const COMPANIES_KEY = ["companies"] as const;
const PAGE_SIZE = 25;

export function useCompanyList(query: CompanyQuery) {
  return useInfiniteQuery({
    queryKey: [...COMPANIES_KEY, "list", query],
    queryFn: ({ pageParam }) => listCompanies({ ...query, cursor: pageParam, limit: PAGE_SIZE }),
    initialPageParam: null as string | null,
    getNextPageParam: (last) => last.next_cursor,
  });
}

/** Only the filter counters (independent of the chosen filter). */
export function useCompanyCounts(q: string) {
  return useQuery({
    queryKey: [...COMPANIES_KEY, "counts", q],
    queryFn: async () => (await listCompanies({ q, limit: 1 })).counts,
  });
}

export function useCompanyDetail(id: string | undefined) {
  return useQuery({
    queryKey: [...COMPANIES_KEY, "detail", id],
    queryFn: () => getCompany(id ?? ""),
    enabled: id !== undefined,
  });
}
